import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { OrderHistoryService } from '../../../../order-history/order-history.service';

// const emailRegexExp =
//     '^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$';
const emailRegexExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;

@Component({
    selector: 'app-fax-email-popup',
    templateUrl: './fax-email-popup.component.html',
    styleUrls: ['./fax-email-popup.component.scss']
})
export class FaxEmailPopupComponent implements OnInit, OnDestroy {

    emailFaxForm: FormGroup;
    @Input() noOfInvoices;
    @Input() userId;
    @Input() invoicesList;    //To be required to send to post request
    @Input() reqType;

    @Output() popupCloseEvent = new EventEmitter<string>();


    subscriptions = new Subscription();
    saveClicked: boolean;
    errorOnSave: boolean = false;
    isSaveComplete: boolean = false;
    successMessage: string = '';
    baseSiteId: string;


    constructor(public activeModal: NgbActiveModal,
        private readonly user: UserAccountFacade,
        private readonly ref: ChangeDetectorRef,
        private readonly fb: FormBuilder,
        private readonly orderHistoryService: OrderHistoryService,
        private baseSiteService: BaseSiteService) { }

    ngOnInit(): void {
        this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
        this.initializeForm();
    }

    initializeForm() {
        this.saveClicked = false;
        this.emailFaxForm = this.fb.group({
            contactMethod: ['MAIL', [Validators.required]],
            email: ['', [Validators.required,
            Validators.email,
            Validators.pattern(emailRegexExp)]],
            fax: [{ value: '', disabled: true }],
            coverSheet: [false, [Validators.required]],
            attention: [''],
            comments: ['']
        });

        //Conditional Validation for radio inputs
        this.subscriptions.add(this.emailFaxForm.get('contactMethod').valueChanges
            .subscribe(radioButtonValue => {
                const email = this.emailFaxForm.get('email');
                const fax = this.emailFaxForm.get('fax');
                if (radioButtonValue === 'MAIL') {
                    email.enable();
                    email.setValidators([Validators.required,
                    Validators.email,
                    Validators.pattern(emailRegexExp)]);
                    fax.setValue('');
                    fax.disable();
                    this.emailFaxForm.get('coverSheet').setValue(false);
                    this.emailFaxForm.get('attention').setValue('');
                    this.emailFaxForm.get('comments').setValue('');
                    fax.clearValidators();
                }
                else {
                    fax.enable();
                    fax.setValidators([Validators.required, Validators.maxLength(12), Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]);
                    email.setValue('');
                    email.disable();
                    email.clearValidators();
                }
                //update the validitors status
                email.updateValueAndValidity();
                fax.updateValueAndValidity();
            })
        );

        this.subscriptions.add(this.emailFaxForm.get('fax').valueChanges.subscribe(faxVal => {
            if (faxVal) {
                switch (faxVal.length) {
                    case 1:
                        if (!/^\d{1}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 2:
                        if (!/^\d{2}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 3:
                        if (!/^\d{3}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 4:
                        if (!/[\d-]$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        else {
                            //checking what is the last value and accordingly act
                            const firstPart = faxVal.slice(0, faxVal.length - 1);
                            const lastChar = faxVal.slice(-1);
                            if (lastChar !== "-")
                                this.emailFaxForm.controls.fax.setValue(firstPart + "-" + lastChar, {
                                    emitEvent: false
                                });
                        }
                        break;
                    case 5:
                        if (!/^\d{3}-\d{1}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 6:
                        if (!/^\d{3}-\d{2}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 7:
                        if (!/^\d{3}-\d{3}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 8:
                        if (!/[\d-]$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        else {
                            const firstPart = faxVal.slice(0, faxVal.length - 1);
                            const lastChar = faxVal.slice(-1);
                            if (lastChar !== "-")
                                this.emailFaxForm.controls.fax.setValue(firstPart + "-" + lastChar, {
                                    emitEvent: false
                                });
                        }
                        break;
                    case 9:
                        if (!/^\d{3}-\d{3}-\d{1}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 10:
                        if (!/^\d{3}-\d{3}-\d{2}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 11:
                        if (!/^\d{3}-\d{3}-\d{3}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 12:
                        if (!/^\d{3}-\d{3}-\d{4}$/.test(faxVal))
                            this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                                emitEvent: false
                            });
                        break;
                    case 13:
                        this.emailFaxForm.controls.fax.setValue(faxVal.slice(0, -1) + '', {
                            emitEvent: false
                        });
                        break;
                }
            }
        })
        );
    }

    closeModal() {
        this.activeModal.close();
        this.popupCloseEvent.emit('closed');
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    saveDetails() {
        this.saveClicked = true;
        this.ref.detectChanges();
        let emailFaxForm = this.emailFaxForm.getRawValue();
        this.filterInvoiceList(emailFaxForm);
        //if coverSheet is false, send option and attention as empty
        //depending on the contact method, keep email or fax empty.
        //this.closeModal();
    }
    filterInvoiceList(formRawData) {
        let invoices = this.invoicesList.map(item => {
            const parts = item?.split('_checkbox_');
            if (parts?.length === 2) {
                return parts[1];
            }
            return null;
        })?.filter(item => item !== null);
        const uniqueListOfInvoices = [...new Set(invoices)];

        let reqObj = {
            invoiceID: uniqueListOfInvoices,
            contactMethod: formRawData?.contactMethod === 'MAIL' ? 'email' : 'fax',
            email: formRawData?.contactMethod === 'MAIL' ? formRawData?.email : '',
            fax: formRawData?.contactMethod !== 'MAIL' ? formRawData?.fax : '',
            coverSheet: formRawData?.coverSheet ? 'on' : 'off',
            attentionTo: formRawData?.coverSheet ? formRawData?.attention : '',
            comments: formRawData?.coverSheet ? formRawData?.comments : '',
            recordType: this.reqType ? this.reqType : 'ro'
        };

        this.orderHistoryService.sendInvoicesViaMailOrFax(this.userId, reqObj).subscribe(res => {
            if (res && res !== null) {
                if (res?.status === 'SUCCESS' || res?.status === 'Partial Success') {
                    this.errorOnSave = false;
                    this.isSaveComplete = true;
                    this.successMessage = 'Your invoices have been sent.';
                    if (res?.status === 'Partial Success' && res?.errorInvoices && res?.errorInvoices?.length > 0) {
                        this.successMessage = 'Your invoices have been sent except for - ';
                        res?.errorInvoices?.forEach((item, index) => {
                            if (index == 0) {
                                this.successMessage = this.successMessage + item;
                            }
                            else {
                                this.successMessage = this.successMessage + ', ' + item;
                            }
                        });
                        this.successMessage = this.successMessage + '.';
                    }
                }
                else {
                    this.errorOnSave = true;
                    this.isSaveComplete = true;
                }
                this.ref.detectChanges();
            }
        }, errors => {
            this.errorOnSave = true;
            this.isSaveComplete = true;
            this.ref.detectChanges();
        });
    }

}
